import { Button, Tooltip, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { copyToClipboard, passengerCopyText } from './passengerColumns';

/**
 * SHAR-127 — copies ONE passenger's details to the clipboard, one line per
 * value, beside the row's Edit / Remove buttons. Used by the ShareJet booking's
 * passenger tables and the charter booking's (CharterPassengers).
 */
export function CopyPassengerButton({ passenger }: { passenger: Parameters<typeof passengerCopyText>[0] }) {
  return (
    <Tooltip title="Copy passenger details">
      <Button
        size="small"
        icon={<CopyOutlined />}
        aria-label="Copy passenger details"
        onClick={async () => {
          try {
            await copyToClipboard(passengerCopyText(passenger));
            message.success('Passenger details copied');
          } catch {
            message.error('Could not copy to the clipboard');
          }
        }}
      />
    </Tooltip>
  );
}
